import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../../constants/ActionTypes";
import ApiUrls from "../../../../constants/ApiUrls";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";
import ProductFactory from "../../../../factories/product/ProductFactory";
import { apiRequest } from "../../api/actions";
import {
  createErrorNotification,
} from "../../notification/actions";
import { setLoader } from "../../ui/actions";
import { enrichProductSuggestionsAction, setProductSuggesstions } from "./actions";

export const getProductSuggestionsMiddleware: Middleware =
  (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
    next(action);
    switch (action.type) {
    case ActionTypes.PRODUCT.GET_PRODUCT_SUGGESTIONS:
      next(
        apiRequest(
          null,
          "GET",
          `${ApiUrls.PRODUCTS}/${action.payload.manufacturer}/${action.payload.productName}${ApiUrls.PRODUCT_SUGGESTIONS}`,
          {
            lang: action.payload.lang,
            section: action.payload.section
          },
          null,
          MiddlewareEntities.PRODUCT_SUGGESTIONS,
          {}
        )
      );
      next(setLoader(true, MiddlewareEntities.PRODUCT_SUGGESTIONS));
      break;
    case `${MiddlewareEntities.PRODUCT_SUGGESTIONS} ${ActionTypes.API_SUCCESS}`:
      next(enrichProductSuggestionsAction(action.payload.data.products));
      next(setLoader(false, MiddlewareEntities.PRODUCT_SUGGESTIONS));
      break;
    case `${MiddlewareEntities.PRODUCTS} ${ActionTypes.API_ERROR}`:
      next(setLoader(false, MiddlewareEntities.PRODUCTS));
      next(
        createErrorNotification(
          action.payload.data,
          MiddlewareEntities.PRODUCTS
        )
      );
      break;
    }
  };

export const enrichProductSuggestionsMiddleware: Middleware =
  (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
    next(action);

    if (action.type === ActionTypes.PRODUCT.ENRICH_PRODUCT_SUGGESTIONS) {
      const products = action.payload;
      const productSuggestions = products.map((product: any) => {
        return ProductFactory.createFromResponse(product);
      });
      next(setProductSuggesstions(productSuggestions));
    }
  };

export const productSuggestionsMiddleware = [
  getProductSuggestionsMiddleware,
  enrichProductSuggestionsMiddleware
];
